import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import SuiteLayout from './components/layout/SuiteLayout';
import BottomNavBar from './components/layout/BottomNavBar';
import AdminRoute from './components/AdminRoute';
import Login from './views/Login';
import Dashboard from './views/Dashboard';
import StaffDashboard from './views/StaffDashboard';
import MarketingDashboard from './views/MarketingDashboard';
import InventoryDashboard from './views/InventoryDashboard';
import Configuracion from './views/Configuracion';
import FinanceDashboard from './views/FinanceDashboard';
import Rentabilidad from './views/ProfitabilityView';
import Validacion from './views/Supervisor/AuditView';
import Supervision from './views/Supervisor/SupervisorLog';
import NotificationsView from './views/NotificationsView';

const App = () => {
  const { currentUser, loading, logout } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-slate-950 text-emerald-500">Cargando...</div>;
  if (!currentUser) return <Routes><Route path="/login" element={<Login />} /><Route path="*" element={<Navigate to="/login" replace />} /></Routes>;

  return <SuiteLayout user={currentUser} onLogout={logout}><Routes>
    <Route path="/" element={<Dashboard />} /><Route path="/personal" element={<StaffDashboard />} /><Route path="/marketing" element={<MarketingDashboard />} /><Route path="/inventario" element={<InventoryDashboard />} />
    <Route path="/configuracion" element={<AdminRoute><Configuracion /></AdminRoute>} />
    <Route path="/finanzas" element={<AdminRoute><FinanceDashboard /></AdminRoute>} />
    <Route path="/rentabilidad" element={<AdminRoute><Rentabilidad /></AdminRoute>} />
    <Route path="/validacion" element={<AdminRoute><Validacion /></AdminRoute>} />
    <Route path="/supervision" element={<AdminRoute><Supervision /></AdminRoute>} />
    <Route path="/notificaciones" element={<NotificationsView />} />
    <Route path="/login" element={<Navigate to="/" replace />} /><Route path="*" element={<Navigate to="/" replace />} />
  </Routes><BottomNavBar /></SuiteLayout>;
};
export default App;

